import { setSliceIsShowSubtitle, setSliceSelectedType } from '../../../../redux/slices/FJSliceRightTextBaseEditing';
import FJTextBaseEditingRightHeader from '../view/FJTextBaseEditingRightHeader';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionRightTextBaseEditing from '../../../../redux/action/textBasedEditing/FJActionRightTextBaseEditing.js';
import useLocalStore from '../../../../hooks/useLocalStore.js';

const FJTextBaseEditingRightHeaderContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isShow = useSelector(state => state.common.isDone);
    const isApplyButton = useSelector(state => state.common.isApplyButton);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);
    const selectedType = useSelector(state => state.rightTextBaseEditing.selectedType);
    const isShowSubtitle = useSelector(state => state.rightTextBaseEditing.isShowSubtitle);
    const isEditPage = window.isEditPage;

    const changeSelectedType = useCallback(
        value => {
            dispatch(setSliceSelectedType(value));
        },
        [dispatch],
    );

    const changeIsShowSubtitle = useCallback(
        value => {
            dispatch(setSliceIsShowSubtitle(value));
        },
        [dispatch],
    );

    const downloadVideo = useCallback(() => {
        dispatch(FJActionRightTextBaseEditing.downloadVideoAction());
    }, [dispatch]);

    const exportVideo = useCallback(() => {
        dispatch(FJActionRightTextBaseEditing.exportAction());
    }, [dispatch]);

    return (
        <FJTextBaseEditingRightHeader
            isShow={isShow}
            isApplyButton={isApplyButton}
            batchDownloadLoading={batchDownloadLoading}
            isEditPage={isEditPage}
            selectedType={selectedType}
            isShowSubtitle={isShowSubtitle}
            changeSelectedType={changeSelectedType}
            changeIsShowSubtitle={changeIsShowSubtitle}
            exportVideo={exportVideo}
            downloadVideo={downloadVideo}
        />
    );
};

export default FJTextBaseEditingRightHeaderContainer;
